import { __ } from '@wordpress/i18n';
import { SelectControl } from '@wordpress/components';

const PageSelector = ( {
	label,
	value,
	pages,
	onChange,
	help,
	showLink = true,
	getLinkForLanguagePage,
	getTitleForLanguagePage,
} ) => {
	return (
		<div>
			<SelectControl
				label={ label }
				value={ value }
				options={ [
					{ label: __( 'Select a page...', 'linear' ), value: '' },
					...( pages
						? pages.map( ( page ) => ( {
								label: page.title.raw,
								value: page.id,
						  } ) )
						: [] ),
				] }
				onChange={ onChange }
				help={ help }
			/>
			{ showLink && value && pages && getLinkForLanguagePage ? (
				<div style={ { marginTop: '5px' } }>
					<p>
						{ __( 'Link to page: ', 'linear' ) }
						<a
							href={ getLinkForLanguagePage() }
							target="_blank"
							rel="noopener noreferrer"
						>
							{ getTitleForLanguagePage() }
						</a>
					</p>
				</div>
			) : (
				''
			) }
		</div>
	);
};

export { PageSelector };
